import { cn } from "@/utils/Functions";
import type { Screen, ScreenProps } from "../screens/types";
import { toast } from "sonner";

export const Navigation = ({ selectedScreen, setSelectedScreen }: ScreenProps) => {
  const navigation = [
    {
      id: 'initial',
      label: '1. Select a contract',
    },
    {
      id: 'fill',
      label: '2. Fill contract',
    },
    {
      id: 'preview',
      label: '3. Preview & Collaborate',
    },
    {
      id: 'save',
      label: '4. Save & Sign',
    },
  ] 
  
  return (
    <div className="relative md:sticky top-0 h-auto md:h-screen py-8 md:py-32">
      <div className="h-32">
        <h1 className="text-3xl font-bold">Contract Composer</h1>
        <h2 className="text-neutral-400 font-medium">Analyse in EQ or IQ Mode</h2>
      </div>

      <div className="font-medium flex flex-col items-start gap-2">
        {navigation.map((item) => (
          <button 
            className={cn(selectedScreen.id === item.id ? 'text-white' : 'text-neutral-400')} 
            onClick={() => {
              if (item.id === 'save') {
                toast.warning('Demo mode', {
                  description: 'Sign is not available in demo mode'
                });
                return;
              }
              setSelectedScreen(item.id);
            }} 
            key={item.id}
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  )
}
